import {
    AskRequest,
    AskResponse,
    ChatRequest,
    FeedBackReq,
    FeedBackRes,
    dataUserReq,
    dataUserRes,
    dataFavQuestionsReq,
    dataFavQuestionsRes,
    loginTokenResponse,
    dataHistQuestionsRes
} from "./models";
import { dataUsers } from "../infraestructure/userData.json";

export async function askApi(options: AskRequest): Promise<AskResponse> {
    console.log("Dentro de ASK API v2");
    const response = await fetch("/ask", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            question: options.question,
            approach: options.approach,
            overrides: {
                semantic_ranker: options.overrides?.semanticRanker,
                semantic_captions: options.overrides?.semanticCaptions,
                top: options.overrides?.top,
                temperature: options.overrides?.temperature,
                prompt_template: options.overrides?.promptTemplate,
                prompt_template_prefix: options.overrides?.promptTemplatePrefix,
                prompt_template_suffix: options.overrides?.promptTemplateSuffix,
                exclude_category: options.overrides?.excludeCategory
            }
        })
    });

    const parsedResponse: AskResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse;
}

export async function chatApi(options: ChatRequest): Promise<AskResponse> {
    const response = await fetch("/conversation/chat", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },

        body: JSON.stringify({
            history: options.history,
            approach: options.approach,
            token: options.token,
            scope: options.scope,
            isTest: "false",
            overrides: {
                semantic_ranker: options.overrides?.semanticRanker,
                semantic_captions: options.overrides?.semanticCaptions,
                top: options.overrides?.top,
                suggest_followup_questions: options.overrides?.suggestFollowupQuestions
            },
            selectedButton: options.selectedButton,
            seccion: options.seccion
        })
    });

    const parsedResponse: AskResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse;
}

export function getCitationFilePath(citation: string): string {
    return `/conversation/content/${citation}`;
}
export async function sendDataLikeDislikeButton(fields: FeedBackReq, token: string): Promise<FeedBackRes> {
    const response = await fetch("/api/saveFeedback", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            feedback: {
                messageId: fields.messageId,
                question: fields.Question,
                answer: fields.Answer,
                scope: fields.Scope,
                negocio: fields.Negocio,
                acceso: fields.Acceso,
                centro: fields.Centro,
                partitionKey: fields.PartitionKey,
                Content: {
                    OK: fields.Content.OK,
                    FeedbackComment: fields.Content.FeedbackComment
                },
                Links: {
                    OK: fields.Links.OK,
                    FeedbackComment: fields.Links.FeedbackComment
                },
                Reason: {
                    OK: fields.Reason.OK,
                    FeedbackComment: fields.Reason.FeedbackComment
                },
                OverallFeedback: fields.OverallFeedback,
                docs_respuesta: fields.Docs_respuesta,
                docs_otros_enlaces: fields.Docs_otros_enlaces,
                token: token,
                ButtonClickTime: fields.ButtonClickTime,
                selected_button: fields.selected_button,
                question_intention: fields.question_intention,
                language: fields.language,
                chain_of_thought: fields.chain_of_thought
            }
        })
    });
    const parsedResponse: FeedBackRes = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse;
}

export async function saveLastScope(scope: String, seccion: String): Promise<dataUserRes> {
    let parsedResponse: dataUserRes = { response: "" };
    try {
        const response = await fetch("/api/updateLastScope", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                scope: scope,
                seccion: seccion
            })
        });
        parsedResponse = await response.json();
        if (response.status > 299 || !response.ok) {
            throw Error("Unknown error");
        }
    } catch (error) {
        console.log(error);
        parsedResponse.error = error;
        return parsedResponse;
    } finally {
        return parsedResponse;
    }
}

export async function receiveLastScope(section: string, source: string) {
    const response = await fetch(`/api/getlastscopes?section=${section}&source=${source}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const parsedResponse: string = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error("Unknown error");
    }
    return parsedResponse;
}

export async function sendFavQuestions(fields: dataFavQuestionsReq, token: string) {
    console.log("Verificando ButtonClickTime antes de enviar:");
    if (!fields.ButtonClickTime) {
        console.log("ButtonClickTime no presente, generando nuevo timestamp.");
        fields.ButtonClickTime = Date.now(); // Genera el timestamp actual en milisegundos
    }
    const response = await fetch("/api/addfavuser", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            saveFavUser: fields,
            token: token,
            ButtonClickTime: fields.ButtonClickTime
        })
    });

    const parsedResponse: dataFavQuestionsRes = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error("Unknown error");
    }
    return parsedResponse;
}

export async function receiveFavQuestions(scope: string, seccion: string, loginMethod: string) {
    const response = await fetch(`/api/getfavuser?scope=${scope}&seccion=${seccion}&loginMethod=${loginMethod}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const parsedResponse: dataFavQuestionsRes = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error("Unknown error");
    }
    return parsedResponse;
}

export async function deleteFavQuestion(fields: dataFavQuestionsReq) {
    const response = await fetch("/api/delfavuser", {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            delFavUser: fields
        })
    });
    const parsedResponse: dataFavQuestionsRes = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error("Unknown error");
    }
    return parsedResponse;
}

export async function sendLoginToken(token: string) {
    const sendedToken = await fetch("/token", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            token: token
        })
    });
    const response: loginTokenResponse = await sendedToken.json();
    if (response.status !== 200) {
        throw Error(`HTTP ERROR ${response.status}`);
    }
    return response;
}


export async function sendFlagNewChat(user: dataUserReq, token: string, buttonClickTime: number, imageNames: string[]) {
    let parsedResponse: dataUserRes = { response: "" };
    try {
        const response = await fetch("/api/newchat", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                user: user,
                token: token,
                buttonClickTime: buttonClickTime, // Envía el tiempo de clic
                imageNames: imageNames
            })
        });
        parsedResponse = await response.json();
        if (response.status > 299 || !response.ok) {
            throw Error("Unknown error");
        }
    } catch (error) {
        console.log(error);
        parsedResponse.error = error;
        return parsedResponse;
    } finally {
        return parsedResponse;
    }
}

type HistQuestion = {
    question: string;
};

export async function receiveHistQuestions(scope: string, seccion: string, loginMethod: string): Promise<HistQuestion[]> {
    try {
        const response = await fetch(`/api/gethistuser?scope=${scope}&seccion=${seccion}&loginMethod=${loginMethod}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });
        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
        const parsedResponse: HistQuestion[] = await response.json();
        return parsedResponse;
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
}

export async function fetchImageUrl(seccion: string): Promise<{ urls: string[]; names: string[] }> {
    try {
        // Usar el endpoint más optimizado que NO causa OOM
        const response = await fetch(`/api/get-image-metadata?section=${seccion}`);
        const data = await response.json();
        
        // Convertir metadatos a formato compatible con el código existente
        const urls = data.images?.map((img: any) => `/api${img.url}`) || [];
        const names = data.images?.map((img: any) => img.name) || [];
        
        return { urls, names };
    } catch (error) {
        console.error("Error fetching image metadata:", error);
        return { urls: [], names: [] };
    }
};

export interface FrontendConfig {
    promocionesIndexEnabled: boolean;
}

export async function getFrontendConfig(): Promise<FrontendConfig> {
    try {
        const response = await fetch("/elypse/frontendConfig", {
            method: "GET",
            headers: { "Content-Type": "application/json" }
        });
        if (!response.ok) {
            return { promocionesIndexEnabled: true };
        }
        const data = await response.json();
        return { promocionesIndexEnabled: data.promocionesIndexEnabled !== false };
    } catch (error) {
        console.error("Error fetching frontend config:", error);
        return { promocionesIndexEnabled: true };
    }
}